import React from "react";

const LINK = /\[([^\]]{1,120})\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>()\]]+)/g;

const hostOf = (url: string) => {
    try {
        return new URL(url).hostname.replace(/^www\./, "");
    } catch {
        return url;
    }
};

/**
 * An answer line with its web addresses as links: a markdown link keeps its
 * label, a bare address shows its site name. Everything else stays plain text.
 */
export const inlineWithLinks = (text: string): React.ReactNode[] => {
    const parts: React.ReactNode[] = [];
    let last = 0;
    let n = 0;
    const pattern = new RegExp(LINK.source, "g");
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text)) !== null) {
        const at = match.index;
        if (at > last) parts.push(text.slice(last, at));
        const raw = match[2] ?? match[3];
        // a sentence's full stop or comma after a bare address isn't part of it
        const url = match[1] ? raw : raw.replace(/[.,;:]+$/, "");
        const label = match[1] ?? hostOf(url);
        parts.push(<a key={`a${n++}`} href={url} target="_blank" rel="noopener noreferrer" title={`Open ${hostOf(url)} on the web`}>{label}</a>);
        last = at + match[0].length - (raw.length - url.length);
    }
    if (last < text.length) parts.push(text.slice(last));
    return parts.length ? parts : [text];
};
